import { Controller } from "@hotwired/stimulus"

// Keeps a running count of the ticked checkboxes inside it (TMS-1763, the newsletters chosen at
// membership registration and in Settings → Newsletter), including none. The server renders the
// same words for the first paint (newsletter_selection_count).
export default class extends Controller {
  static targets = ["output"]
  static values = { none: String, one: String, other: String }

  connect() {
    this.update()
  }

  update() {
    const count = this.element.querySelectorAll("input[type='checkbox']:checked").length
    const template = count === 0 ? this.noneValue : (count === 1 ? this.oneValue : this.otherValue)
    this.outputTarget.textContent = template.replace("%{count}", count)
  }
}
